import * as React from "react";
import { Tooltip, message } from "antd";
// 浏览器复制
import { CopyToClipboard } from "react-copy-to-clipboard";
import { TextAlignProperty } from "csstype";

const showMessage = () => {
  message.config({
    duration: 1,
    maxCount: 1
  });
  message.info("复制成功");
};

const style = {
  padding: "0 8px",
  display: "inline-block",
  cursor: "pointer"
};

// 获取父节点
const getContainer = containerBody => {
  if (containerBody) {
    return document.querySelector(containerBody) || document.body;
  } else {
    return document.body;
  }
};

const showGroupNumber = (text, containerBody) => {
  const _getContainer = () => {
    return getContainer(containerBody);
  };

  if (!text) {
    return (
      <div style={{ width: "100%", textAlign: "center" as TextAlignProperty }}>
        -
      </div>
    );
  } else {
    const renderHtml = (
      <CopyToClipboard text={text}>
        <Tooltip title="点击复制到剪切板" getTooltipContainer={_getContainer}>
          <div onClick={showMessage} style={style}>
            <i className="action-user action-fuzhi" />
            {text}
          </div>
        </Tooltip>
      </CopyToClipboard>
    );
    return renderHtml;
  }
};

export default containerBody => {
  return {
    render: (text, record) => {
      return showGroupNumber(text, containerBody);
    },
    onCell: () => {
      return {
        className: "td-text-algn-left"
      };
    }
  };
};
